module.exports = __webpack_public_path__ + "images/emoji/tophat.8f46bf1708587bad37f8.png";